import { GRANT_ACTOR_DISPLAY_NAME, parseActorLabel } from "encamp-shared/src/auth/actorLabel";
import { isSubmissionRecordComment } from "encamp-shared/src/submissions/recordComments";
import { ENCAMP_STAFF_DISPLAY_NAME } from "encamp-shared/src/submissions/staffDisplay";
import { CommentThreadFragment } from "generated-graphql/graphql";

export function isCommentDeletableByUser(
  comment: Pick<CommentThreadFragment, "isSystemMessage" | "isProtected"> & {
    user?: { id: string } | null;
  },
  currentUserId: string | undefined
): boolean {
  return Boolean(
    currentUserId && comment.user?.id === currentUserId && !isSubmissionRecordComment(comment)
  );
}

export const AUTOMATED_COMMENT_AUTHOR = "Encamp System";

/**
 * Without a user, a system message was written by a job, whose audit name means
 * nothing to readers, and a protected record comment was written by Encamp,
 * which customers see as Encamp Staff rather than the employee.
 */
export function getCommentAuthor(
  comment: Pick<CommentThreadFragment, "updatedBy" | "isSystemMessage" | "isProtected"> & {
    user?: { email?: string | null } | null;
  }
): string {
  if (comment.user?.email) {
    return comment.user.email;
  }
  if (comment.isSystemMessage) {
    return AUTOMATED_COMMENT_AUTHOR;
  }
  if (comment.isProtected) {
    return ENCAMP_STAFF_DISPLAY_NAME;
  }
  return commentWriterDisplay(comment.updatedBy);
}

/** A comment's stored writer, for when it has no user; a grant acting alone reads as Scout. */
export function commentWriterDisplay(updatedBy: string | null | undefined): string {
  if (!updatedBy) return "Someone";
  return parseActorLabel(updatedBy).userId === null ? GRANT_ACTOR_DISPLAY_NAME : updatedBy;
}
